module.exports = __webpack_public_path__ + "static/img/sdwyj_img1.402be71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sdwyj_img1.png
// module id = rxEq
// module chunks = 1